import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { STATUS_COLORS } from '../../config/constants';

const StatusBadge = ({ status }) => {
  const color = STATUS_COLORS[status] || '#9DA9BB';

  return (
    <Chip
      label={status}
      size="small"
      sx={{
        backgroundColor: alpha(color, 0.12),
        color: color,
        fontWeight: 500,
        fontSize: '0.6875rem',
        border: 'none',
        letterSpacing: '0.01em',
        '& .MuiChip-label': { px: 1.25 },
      }}
    />
  );
};

export default StatusBadge;
